import Headroom from 'headroom.js';
import { headerHeight } from '../helpers';

if (!window.dAgency) window.dAgency = {};

$(function () {
  const $siteHeader = $(".site-header");
  const $header = $siteHeader.find(".header__container");
  if ($siteHeader <= 0 || $header.length <= 0) return false;

  $("html").css("scroll-padding-top", headerHeight() + "px");
  $("#CartPopup").css("top", headerHeight() + "px");

  $(window).on("resize", function () {
    $("html").css("scroll-padding-top", headerHeight() + "px");
    $("#CartPopup").css("top", headerHeight() + "px");
  });

  /* ====================== HeadrooomJS ====================== */
  const header = document.querySelector("header.site-header");
  if (header) {
    const options = {
      tolerance: {
        up: 20,
        down: 20,
      },
      onPin: function () {
        if (this.elem) {
          const $announcement = $(this.elem).find(
            "#shopify-section-announcement-bar"
          );
          if ($announcement.length > 0) {
            $announcement.slideDown(250);

            const $searchPopup = $(".header__search-popup");
            console.log("here");
            if ($searchPopup.length > 0) {
              $deskSearchBar.css("top", headerHeight() + "px");
              $searchPopup.css("top", headerHeight() + "px");
            }
            $(mobileMenu).css("top", headerHeight() + "px");
            $(mobileMenu).css(
              "height",
              "calc(100vh - " + headerHeight() + "px)"
            );
          }
        }
      },
      onUnpin: function () {
        if (this.elem) {
          const $announcement = $(this.elem).find(
            "#shopify-section-announcement-bar"
          );
          if ($announcement.length > 0) {
            $announcement.slideUp(250);

            console.log("unpin");

            const $searchPopup = $(".header__search-popup");
            if ($searchPopup.length > 0) {
              $deskSearchBar.css("top", headerHeight() + "px");
              $searchPopup.css("top", "calc(" + headerHeight() + "px - 34px)");
            }
            $(mobileMenu).css("top", headerHeight() + "px");
            $(mobileMenu).css(
              "height",
              "calc(100vh - " + headerHeight() + "px)"
            );
          }
        }
      },
    };

    const headroom = new Headroom(header, options);
    headroom.init();
  }

  /* ======================== Mobile Menu ======================== */
  const mobileMenu = document.querySelector(
    ".header__mobile-menu.header__mobile-menu--dropdown"
  );
  if (mobileMenu != null) {
    mobileMenu
      .querySelectorAll(
        ".header__mobile-menu--dropdown__navigation__first-level__title[data-link-opener]"
      )
      .forEach((firstLevelItem) => {
        firstLevelItem.addEventListener("click", (e) => {
          e.preventDefault();

          if (firstLevelItem.querySelector("a.active") != null) {
            return;
          }
          mobileMenu
            .querySelector(
              ".header__mobile-menu--dropdown__navigation__first-level__title a.active"
            )
            ?.classList.remove("active");
          mobileMenu
            .querySelector(
              ".header__mobile-menu--dropdown__navigation__second-level.open"
            )
            ?.classList.remove("open");

          const drawerAttribute = firstLevelItem.dataset.linkOpener;
          const secondLevelItem = mobileMenu.querySelector(
            '.header__mobile-menu--dropdown__navigation__second-level[data-level="' +
              drawerAttribute +
              '"]'
          );
          if (secondLevelItem == null) {
            return;
          }

          secondLevelItem.classList.add("open");
          firstLevelItem.querySelector("a").classList.add("active");
        });
      });

    mobileMenu
      .querySelectorAll(
        ".header__mobile-menu--dropdown__navigation__second-level"
      )
      .forEach((secondLevelItem) => {
        secondLevelItem
          .querySelectorAll(
            ".header__mobile-menu--dropdown__navigation__second-level__title"
          )
          .forEach((secondLevelItemTitle) => {
            secondLevelItemTitle.addEventListener("click", (e) => {
              e.preventDefault();

              if(secondLevelItemTitle.hasAttribute('data-link')){
                  let link = secondLevelItemTitle.getAttribute('data-link');
                  document.location.href = link;
              }

              const drawerAttribute = secondLevelItemTitle.dataset.linkOpener;
              const thirdLevelItem = secondLevelItem.querySelector(
                '.header__mobile-menu--dropdown__navigation__third-level[data-level="' +
                  drawerAttribute +
                  '"]'
              );
              if (thirdLevelItem == null) {
                return;
              }

              thirdLevelItem.classList.add("open");
              mobileMenu
                .querySelectorAll(
                  ".header__mobile-menu--dropdown__navigation__second-level__title"
                )
                .forEach(
                  (secondLevelItemTitle) =>
                    (secondLevelItemTitle.style.opacity = 0)
                );
              mobileMenu
                .querySelectorAll(
                  ".header__mobile-menu--dropdown__navigation__first-level__title"
                )
                .forEach(
                  (firstLevelItemTitle) =>
                    (firstLevelItemTitle.style.opacity = 0)
                );
              mobileMenu.querySelector(
                ".header__mobile-menu--dropdown__footer"
              ).style.display = "none";
            });
          });
      });

    mobileMenu
      .querySelectorAll(
        ".header__mobile-menu--dropdown__navigation__third-level"
      )
      .forEach((thirdLevelItem) => {
        thirdLevelItem
          .querySelector(
            ".header__mobile-menu--dropdown__navigation__third-level__go-back"
          )
          .addEventListener("click", () => {
            thirdLevelItem.classList.remove("open");

            mobileMenu
              .querySelectorAll(
                ".header__mobile-menu--dropdown__navigation__second-level__title"
              )
              .forEach(
                (secondLevelItemTitle) =>
                  (secondLevelItemTitle.style.opacity = 1)
              );
            mobileMenu
              .querySelectorAll(
                ".header__mobile-menu--dropdown__navigation__first-level__title"
              )
              .forEach(
                (firstLevelItemTitle) => (firstLevelItemTitle.style.opacity = 1)
              );
            mobileMenu.querySelector(
              ".header__mobile-menu--dropdown__footer"
            ).style.display = "block";
          });
      });

    mobileMenu
      .querySelectorAll(".header__mobile-menu--dropdown-navigation__close")
      .forEach((iconClose) => {
        iconClose.addEventListener("click", () => {
          document
            .querySelector(".backdrop-filter.backdrop-filter--mobile")
            .classList.remove("open");
          document.querySelector("html").style.overflowY = "";
          mobileMenu.classList.remove("open");
          $header[0].style.opacity = 1;
        });
      });

    $header[0]
      .querySelector(".header__burger-icon")
      .addEventListener("click", (e) => {
        mobileMenu.classList.add("open");
        document
          .querySelector(".backdrop-filter.backdrop-filter--mobile")
          .classList.add("open");
        document.querySelector("html").style.overflowY = "hidden";
        $header[0].style.opacity = 0;
      });
  }

  /* ======================== Desktop Menu ======================== */
  const desktopMenu = $header[0].querySelector(".header__desktop-menu");
  if (desktopMenu != null) {
    if (desktopMenu.classList.contains("header__desktop-menu--dropdown")) {
      const dropdownInlineElements = desktopMenu.querySelectorAll(
        ".header__desktop-menu--dropdown__inline-elements__link"
      );
      dropdownInlineElements.forEach((dropdownInlineElement) => {
        dropdownInlineElement.addEventListener("mouseenter", () => {
          const dropdownInlineElementWrapper =
            dropdownInlineElement.querySelector(
              ".header__desktop-menu--dropdown__dropdown-wrapper"
            );
          if (dropdownInlineElementWrapper == null) {
            return;
          }

          const searchController = document.querySelector('.header-component__element.search');
          if (searchController != null && searchController.classList.contains('open')) {
            searchController.click();
          }

          const backdropFilter = document.querySelector(
            `.backdrop-filter[data-backdrop-filter="${dropdownInlineElementWrapper.dataset.backdropFilter}"]`
          );
          backdropFilter.style.height = `${dropdownInlineElementWrapper.clientHeight}px`;
          backdropFilter.style.top = `${headerHeight()}px`;
          backdropFilter.classList.add("open");
          dropdownInlineElementWrapper.classList.add("open");
        });

        dropdownInlineElement.addEventListener("mouseleave", () => {
          const dropdownInlineElementWrapper =
            dropdownInlineElement.querySelector(
              ".header__desktop-menu--dropdown__dropdown-wrapper"
            );
          if (dropdownInlineElementWrapper == null) {
            return;
          }

          const backdropFilter = document.querySelector(
            `.backdrop-filter[data-backdrop-filter="${dropdownInlineElementWrapper.dataset.backdropFilter}"]`
          );
          backdropFilter.classList.remove("open");
          dropdownInlineElementWrapper.classList.remove("open");
        });
      });
    }
  }

  /* ==================== Desktop Search PopUp ==================== */
  const $deskSearchBar = $(".header__search-popup");
  const $iconSearch = $header.find(".header__right__element.search");
  const $searchInput = $deskSearchBar.find('form input[type="text"]');

  $deskSearchBar.on('transitionend', function(){
    window.requestAnimationFrame(function() {
      const $deskSearchBar = $(".header__search-popup");
      if($deskSearchBar.length && $deskSearchBar.hasClass('open')){
        $searchInput.trigger("focus");
      } else {
        $searchInput.trigger("blur");
      }
    });
  })

  if ($deskSearchBar.length > 0) {
    $deskSearchBar.css("top", headerHeight() + "px");

    if ($iconSearch.length > 0) {
      $iconSearch.on("click", function (e) {
        e.preventDefault();
        $deskSearchBar.toggleClass("open");
        $iconSearch.toggleClass("open");
      });
    }

    $(window).on("resize", function () {
      if ($(window).outerWidth() <= 1024) {
        $deskSearchBar.css("top", headerHeight() + "px");
      }
    });
  }
});
